import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Globe, ArrowUp } from 'lucide-react';
import Logo from './Logo';
import { LANGS } from '../../data/mock';
import { PILLARS } from '../../data/editorial';
import { ConsentSettingsButton } from '../consent/ConsentBanner';

const CHROME_EXTENSION_URL = 'https://chromewebstore.google.com/detail/glokempaccabmoipcbbejbjleddjelkg';

export default function Footer() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <footer className="site-footer mt-0" data-testid="site-footer">
        <div className="max-w-[1000px] mx-auto px-5 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="flex flex-col items-center md:items-start">
            <Logo size="lg" />
            <p className="text-[13.5px] text-slate-500 mt-4 max-w-[260px] text-center md:text-left leading-relaxed">
              Free Unicode text tools for bios, captions, nicknames and more. Type, pick, copy, paste.
            </p>
          </div>
          <div>
            <h4 className="flex items-center gap-2 text-[19px] font-bold text-slate-800 mb-3">
              <Globe className="w-5 h-5 text-[var(--brand)]" /> Available In / Disponible En
            </h4>
            <ul className="space-y-1.5 pl-9 list-disc">
              {LANGS.map((l) => (
                <li key={l.code} className="text-[14.5px] text-slate-500">
                  <span className="mr-1">{l.flag}</span>{l.label} →{' '}
                  <Link to={l.to} className="text-[var(--brand)] hover:underline" data-testid={`footer-lang-${l.code}`}>{l.link}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-[26px] font-bold text-slate-900 mb-4">Explore</h4>
            <ul className="space-y-2 pl-9 list-disc text-[15px]">
              {[...PILLARS.map(p => [p.title, p.path]), ['Confidentialité', '/fr/confidentialite'], ['Privacy', '/privacy'], ['Home', '/'], ['Blogs', '/blogs'], ['Blog (FR)', '/fr/blog'], ['Bio Instagram', '/instagram-bio-generator'], ['About us', '/about-us'], ['Contact us', '/contact-us']].map(([l, to]) => (
                <li key={to}><Link to={to} className="text-slate-700 hover:text-[var(--brand)] transition-colors" data-testid={`footer-${l.toLowerCase().replace(' ', '-')}`}>{l}</Link></li>
              ))}
              <li><a href={CHROME_EXTENSION_URL} target="_blank" rel="noopener" className="text-slate-700 hover:text-[var(--brand)] transition-colors" data-testid="footer-chrome-extension">Chrome extension</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          Copyright © {new Date().getFullYear()} Cursive Text Generator. All rights reserved.
          <div><ConsentSettingsButton /></div>
        </div>
      </footer>
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`fixed bottom-6 right-6 z-50 w-9 h-9 rounded bg-[var(--brand)] text-white flex items-center justify-center shadow-lg transition-opacity duration-300 hover:bg-[var(--brand-hover)] ${show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        aria-label="Scroll to top" data-testid="scroll-top-btn"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </>
  );
}
